<template>
  <div>
    <div ref="echartsCommon" class="chart"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "",
  props: {
    echartsData: {
      type: Object,
      default: ()=> {}
    }    
  },
  data() {
    return {
      myCharts: null,
      nameList: [],
      xDateList: [],
      chartData: {
        list1: [],
        list2: [],
        list3: [],
      },
    };
  },
  watch: {
    echartsData(val) {
      console.log(val)
      console.log('this.echartsData', this.echartsData)
      this.chartData = {
        list1: this.echartsData.list1,
        list2: this.echartsData.list2,
        list3: this.echartsData.list3
      };
      this.nameList = this.echartsData.nameList;
      this.xDateList = this.echartsData.xDateList;
      this.initChart();
    }
  },
  mounted() {
    console.log('this.echartsData', this.echartsData)

    // var trendingList = [
    //   {orderStartTime: '2019-11-10',
    //    totalPin: 100,
    //    totalPayment: 200,
    //    totalOrder: 300
    //   }
    // ]


    // if (this.trendingList && this.trendingList.length > 0) {
      // var trendingList = this.trendingList;
      // var xDateList = [];
      // var pinList = [];
      // var paymentList = [];
      // var orderList = [];
      // trendingList.forEach(item => {
      //   dateList.push(item.orderStartTime);
      //   pinList.push(item.totalPin);
      //   paymentList.push(item.totalPayment);
      //   orderList.push(item.totalOrder);
      // })
      // this.date = xDateList;
      // this.chartData.list1 = pinList;
      // this.chartData.paymentList = paymentList;
      // this.chartData.orderList = orderList;

      this.$nextTick(() => {
        this.initChart();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      });
    // }
  },
  methods: {
    initChart() {
      this.myCharts = echarts.init(this.$refs.echartsCommon);
      this.setOptions(this.chartData);
    },
    setOptions({list1, list2, list3 } = {}) {
    
      let options = {
        // x轴配置
        xAxis: {
          data: this.xDateList,
          boundaryGap: false,
          axisTick: {
            show: false,
          },
        },
        // 直角坐标系内绘图网格
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
          containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
        },
        // 提示框组件
        tooltip: {
          trigger: "axis", //坐标轴触发
          axisPointer: {
            //指示器类型
            type: "cross",
          },
          padding: [5, 10],
        },
        // y轴配置
        yAxis: {
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        // 图例
        legend: {
          data: this.nameList,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: [
          {
            name: this.nameList[0],
            itemStyle: {
              normal: {
                color: "#FE4D45",
                lineStyle: {
                  color: "#FE4D45",
                  width: 2,
                },
                areaStyle: {
                  //区域填充样式
                  color: "rgba(254,77,69,0.1)",
                },
              },
            },
            smooth: true,
            type: "line",
            data: list1,
            animationDuration: 2800,
            animationEasing: "cubicInOut",
          },
          {
            name: this.nameList[1],
            smooth: true,
            type: "line",
            itemStyle: {
              //折线拐点标志的样式。
              normal: {
                //默认样式
                color: "#4878FF",
                lineStyle: {
                  //线条样式
                  // color: '#3888fa',
                  width: 2,
                },
                areaStyle: {
                  //区域填充样式
                  color: "rgba(8,64,222,0.2)",
                },
              },
            },
            data: list3, //数据
            animationDuration: 2800, //初始动画时长
            animationEasing: "quadraticOut", //初始动画的缓动效果。
          },
           {
            name:  this.nameList[2],
            smooth: true,
            type: "line",
            itemStyle: {
              //折线拐点标志的样式。
              normal: {
                //默认样式
                color: "#1E90FF",
                lineStyle: {
                  //线条样式
                  // color: '#3888fa',
                  width: 2,
                },
                areaStyle: {
                  //区域填充样式
                  color: "rgba(	135,206,250,0.2)",
                },
              },
            },
            data: list2, //数据
            animationDuration: 2800, //初始动画时长
            animationEasing: "quadraticOut", //初始动画的缓动效果。
          },
        ],
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style lang="scss" scoped>
.chart{
  height: 300px;
}
</style>